import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';

import Parse from 'parse';
Parse.serverURL = 'https://parseapi.back4app.com/';
Parse.initialize("be5vX46tPuX4OrqmbOnO7vgueY40Z5juUs98xPDM", "qjlEv4ogp9SE0Uy1e723bKkzj1AOVzNLQcoUDQnf");

class LogOut extends Component{
    render(){
        Parse.User.logOut();
        return(
            <Redirect to="/pages/login-page" />
        )
    }
}

export default LogOut;


// WEBPACK FOOTER //
// ./src/views/Pages/LogOutPage.jsx